<template>
  <widget title="Drop Ships">
    <template v-slot:content>
      <div class="centered large count">{{ dropShips.count }}</div>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'

export default {
  name: 'DropShips',
  components: {
    Widget
  },
  computed: {
    dropShips () {
      return store.state.dashboard.dropShips
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchDropShips')
  }
}
</script>

<style scoped>

</style>
